import * as Actions from "./_ActionTypes";
import * as Pre from "./_PreActionNames";

export function resetWaitingCameraId() {
  return {
    type: Pre.DOORBELL + Actions.PRESSED + "_RESET",
    payload: { },
    socket: {
      send: false,
    },
  };
}

